export default "/images/ASPHO.png?476fe19daa8f18a519f92c4c3e6464b2";